import { CommonModule } from '@angular/common';
import { Component, inject, Input, OnInit } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { map, NEVER, Observable, of } from 'rxjs';

import { AvatarService } from 'app/shared/services/avatar.service';

@UntilDestroy()
@Component({
  selector: 'kh-avatar',
  styleUrls: ['./avatar.component.less'],
  templateUrl: './avatar.component.html',
  imports: [
    CommonModule
  ]
})
export class AvatarComponent implements OnInit {
  private readonly avatarService = inject(AvatarService);

  @Input() public userId: string | null = null;

  @Input() public path: string | null = null;

  public imagePath$: Observable<string> = NEVER;

  public ngOnInit(): void {
    if (this.path) {
      this.imagePath$ = of(this.path);
      return;
    }

    if (this.userId) {
      this.imagePath$ = this.avatarService.getUserAvatar(this.userId).pipe(
        untilDestroyed(this),
        map((avatar) => avatar.avatarURL)
      );
    }
  }
}
